import { render, staticRenderFns } from "./ImportFromReddit.vue?vue&type=template&id=231b87e5&"
import script from "./ImportFromReddit.vue?vue&type=script&lang=ts&"
export * from "./ImportFromReddit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports